import {
  prepareUnsubscribePayload,
  UnsubscribePayload,
  UnsubscriptionBaseService,
} from '@app/shared/views/unsubscription/services/unsubscription.base.service';
import { Observable } from 'rxjs';
import { BaseParamsService } from '@app/core/base-params.service';
import { HttpClient } from '@angular/common/http';

export class EmailUnsubscriptionService extends UnsubscriptionBaseService {

  constructor(
    private http: HttpClient,
    protected baseParamsService: BaseParamsService) {
    super(baseParamsService);
  }

  public unsubscribe(identifier: string, payload: UnsubscribePayload): Observable<unknown> {
    return this.http.put(
      `${this.memberUrl()}/by_email/${identifier}/unsubscribe`,
      prepareUnsubscribePayload(payload),
    );
  }
}
